import { ContentfulEntryType } from './contentful-entry.type';
import { PaymentInfoBlockType } from './payment-info-block.type';

export class LogInType extends ContentfulEntryType {
  public get title(): string {
    return this.fields['title'];
  }

  public get headline(): string {
    return this.fields['headline'];
  }

  public get signUpHeadline(): string {
    return this.fields['signUpHeadline'];
  }

  public get logInHeadline(): string {
    return this.fields['logInHeadline'];
  }

  public get forgotPasswordHeadline(): string {
    return this.fields['forgotPasswordHeadline'];
  }

  public get paymentHeadline(): string {
    return this.fields['paymentHeadline'];
  }

  public get paymentContent(): string {
    return this.fields['paymentContent'];
  }

  public get paymentInfoBlocks(): Array<PaymentInfoBlockType> {
    const entries: ContentfulEntryType[] = this.fields['paymentInfoBlocks'];
    let results: Array<PaymentInfoBlockType> = [];
    for (let entry of entries) {
      results.push(new PaymentInfoBlockType(entry));
    }
    return results;
  }

  public get paymentUserAgreement(): string {
    return this.fields['paymentUserAgreement'];
  }

  public get demographicsHeadline(): string {
    return this.fields['demographicsHeadline'];
  }

  public get practicePlanCheckbox(): string {
    return this.fields['practicePlanCheckbox'];
  }

}


